<div class="page er-bene">

    <div class="pagehead">
        <div>
            <h1 style="text-transform: capitalize;">{{senderName}}</h1>
            <p>Beneficiaries and transfers for this sender</p>
        </div>
    </div>

    <div class="main_section">
        <div class="er-card er-kpi">
            <div class="er-kpi__label">BC limit (monthly)</div>
            <div class="er-kpi__value">{{ 25000 | erInr }}</div>
        </div>
        <div class="er-card er-kpi">
            <div class="er-kpi__label">Transfer limit</div>
            <div class="er-kpi__value">{{ remaininglimit | erInr }}</div>
        </div>
        <div class="er-card er-kpi">
            <div class="er-kpi__label">Transferred amount</div>
            <div class="er-kpi__value">{{ transferredAmt | erInr }}</div>
        </div>
    </div>

    <div class="er-bene-addbar">
        <button type="button" class="er-btn er-btn--primary" (click)='procedWithBc()' *ngIf="isEdit==false">
            Add new beneficiary
            <span class="material-icons">add</span>
        </button>
    </div>

    <div class="er-card er-bene-form" *ngIf='proceedTocBc'>
        <h3 class="er-bene-subhead" *ngIf="isEdit==false">Add beneficiary</h3>
        <h3 class="er-bene-subhead" *ngIf="isEdit">Edit beneficiary</h3>

        <form [formGroup]="addbenifiaryForm" novalidate>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>Name</mat-label>
                        <input matInput placeholder="name" formControlName="name">
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','name')">
                            Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>Mobile no</mat-label>
                        <input matInput placeholder="Enter Mobile Number" formControlName="benemobile">
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','benemobile')">
                            Mobile number is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="matInput" style="width: 100%;">
                        <mat-select placeholder="Title" formControlName="title">
                            <mat-option *ngFor="let type of title" value="{{type}}">{{type}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','title')">
                            Title is required
                        </mat-error>
                    </mat-form-field>

                </div>


            </div>
            <div class="row">

                <div class="col-md-4">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>Address</mat-label>
                        <input matInput placeholder="address" formControlName="address">
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','address')">
                            Address is required
                        </mat-error>
                    </mat-form-field>

                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>City</mat-label>
                        <input matInput placeholder="City" formControlName="city">
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','City')">
                            City is required
                        </mat-error>
                    </mat-form-field>

                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>Pincode</mat-label>
                        <input matInput placeholder="District" formControlName="pincode">
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','pincode')">
                            Pincode is required
                        </mat-error>
                    </mat-form-field>

                </div>

            </div>


            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>Account number</mat-label>
                        <input matInput placeholder="Enter Account Number" formControlName="account_no">
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','account_no')">
                            Account Number is required
                        </mat-error>
                    </mat-form-field>

                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>IFSC code</mat-label>
                        <input matInput placeholder="Enter IFSC Code" formControlName="ifsc">
                        <mat-error *ngIf="addbenifiaryForm.hasError('required','ifsc')">
                            IFSC Code is required
                        </mat-error>
                    </mat-form-field>

                </div>
                <div class="col-md-4">

                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label>Sender mobile no</mat-label>
                        <input matInput placeholder="Sender Mobile No" formControlName="mobile" readonly>
                    </mat-form-field>
                    <mat-error *ngIf="addbenifiaryForm.hasError('required','mobile')">
                        Sender Mobile is required
                    </mat-error>



                </div>

            </div>

        </form>
        <form [formGroup]="otpForm" *ngIf="otpflag" class="er-bene-otp">
            <mat-form-field appearance="outline">
                <mat-label>Enter OTP</mat-label>
                <input matInput type="number" placeholder="OTP" formControlName="otp" type="number" (keyup)="ValidateOTP($event.target.value)" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="6" minlength="6">
            </mat-form-field>
            <mat-error *ngIf="personalInfosubmit && f2.otp.errors">
                <div class="erroeclass" *ngIf="f2.otp.errors.required">
                    Please enter OTP </div>
                <div class="erroeclass" *ngIf="f2.otp.errors.minlength">
                    Min 6 digit is allowed
                </div>
            </mat-error>

            <div class="er-bene-otp-meta">
                <countdown [config]="{leftTime:180}" *ngIf="!isResendEnable" class="er-bene-countdown" (event)="handleEvent($event)">$!m!:$!s!</countdown>
                <small class="er-bene-resend" *ngIf="isResendEnable">Not received yet!
                    <span (click)="resendOTP()" *ngIf="isResendEnable" class="er-bene-resend-link">Resend OTP</span>
                </small><br>
            </div>
        </form>
        <div class="er-bene-form-actions">
            <button type="button" class="er-btn er-btn--ghost" (click)="cancel()">Cancel</button>
            <button type="button" class="er-btn er-btn--primary" (click)="sendOTP()" *ngIf="!otpValidatedflag">Send OTP</button>
        </div>
    </div>

    <div class="er-card er-bene-table-card" *ngIf='!proceedTocBc'>
        <table *ngIf="serviceProvider=='YesBank'" mat-table [dataSource]="dataSource" class="er-bene-table">
            <ng-container matColumnDef="beneficiary_name">
                <th class="tbl-padding" mat-header-cell *matHeaderCellDef> Name </th>
                <td class="tbl-padding" mat-cell *matCellDef="let element" style="text-transform: capitalize;"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="account_no">
                <th class="tbl-padding" mat-header-cell *matHeaderCellDef> Account no </th>
                <td class="tbl-padding" mat-cell *matCellDef="let element"> {{element.accountNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="ifc_code">
                <th class="tbl-padding" mat-header-cell *matHeaderCellDef> IFSC </th>
                <td class="tbl-padding" mat-cell *matCellDef="let element" style="text-transform: uppercase;"> {{element.beneifscCode}} </td>
            </ng-container>
            <ng-container matColumnDef="imps-neft">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-radio-group aria-label="Select an option" [(ngModel)]="transType">
                        <mat-radio-button value="imps">IMPS</mat-radio-button>
                        <mat-radio-button style="margin-left: 15px;" value="neft">NEFT</mat-radio-button>
                    </mat-radio-group>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <div class="sendSection" [ngClass]="{'make-gold': element.block }">
                        <mat-form-field appearance="outline" class="transinput">
                            <input matInput type="number" placeholder="Amount" [(ngModel)]="sendingAmount[i]" [disabled]="element.block">
                        </mat-form-field>
                        <button type="button" class="er-btn er-btn--secondary er-btn--sm transbtn" *ngIf="element.bankVerify==false" (click)="verify(element)">Verify</button>
                        <span class="er-pill er-pill--success er-bene-verified" *ngIf="element.bankVerify==true"><span class="er-dot er-dot--success"></span>Verified</span>


                        <button type="button" class="er-btn er-btn--primary er-btn--sm transbtn" [disabled]="!sendingAmount[i]" (click)="sendmonet(element, sendingAmount[i],confirmationModal)">Send money</button>

                        <mat-icon class="deleteBtn" title="Delete Beneficiary" *ngIf="element.bankVerify==false && element.is_transaction==false" (click)="openmodalforUserDeletion(element._id,blockModal,i)">delete_forever</mat-icon>
                        <mat-icon class="editBtn" title="Edit Beneficiary" *ngIf="element.bankVerify==false && element.is_transaction==false" (click)="editBeneficiary(element,i)">create</mat-icon>


                    </div>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <table *ngIf="serviceProvider!='YesBank'" mat-table [dataSource]="dataSource" class="er-bene-table">
            <ng-container matColumnDef="beneficiary_name">
                <th class="tbl-padding" mat-header-cell *matHeaderCellDef> Name </th>
                <td class="tbl-padding" mat-cell *matCellDef="let element" style="text-transform: capitalize;"> {{element.beneficiary_name}} </td>
            </ng-container>

            <ng-container matColumnDef="account_no">
                <th class="tbl-padding" mat-header-cell *matHeaderCellDef> Account no </th>
                <td class="tbl-padding" mat-cell *matCellDef="let element"> {{element.account_no}} </td>
            </ng-container>

            <ng-container matColumnDef="bank_name">
                <th class="tbl-padding" mat-header-cell *matHeaderCellDef> Bank </th>
                <td class="tbl-padding" mat-cell *matCellDef="let element"> {{element.bank_name}} </td>
            </ng-container>

            <ng-container matColumnDef="ifc_code">
                <th class="tbl-padding" mat-header-cell *matHeaderCellDef> IFSC </th>
                <td class="tbl-padding" mat-cell *matCellDef="let element" style="text-transform: uppercase;"> {{element.ifc_code}} </td>
            </ng-container>
            <ng-container matColumnDef="imps-neft">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-radio-group aria-label="Select an option" [(ngModel)]="transType">
                        <mat-radio-button value="imps">IMPS</mat-radio-button>
                        <mat-radio-button style="margin-left: 15px;" value="neft">NEFT</mat-radio-button>
                    </mat-radio-group>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <div class="sendSection" [ngClass]="{'make-gold': element.block }">
                        <mat-form-field appearance="outline" class="transinput">
                            <input matInput type="number" placeholder="Amount" [(ngModel)]="sendingAmount[i]" [disabled]="element.block">
                        </mat-form-field>
                        <button type="button" class="er-btn er-btn--secondary er-btn--sm transbtn" *ngIf="element.bankVerify==false" (click)="verify(element)">Verify</button>
                        <span class="er-pill er-pill--success er-bene-verified" *ngIf="element.bankVerify==true"><span class="er-dot er-dot--success"></span>Verified</span>


                        <button type="button" class="er-btn er-btn--primary er-btn--sm transbtn" [disabled]="!sendingAmount[i]" (click)="sendmonet(element, sendingAmount[i],confirmationModal)">Send money</button>

                        <mat-icon class="deleteBtn" title="Delete Beneficiary" *ngIf="element.bankVerify==false && element.is_transaction==false" (click)="openmodalforUserDeletion(element._id,blockModal,i)">delete_forever</mat-icon>
                        <mat-icon class="editBtn" title="Edit Beneficiary" *ngIf="element.bankVerify==false && element.is_transaction==false" (click)="editBeneficiary(element,i)">create</mat-icon>


                    </div>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>


    </div>

</div>

<ng-template #blockModal let-modal class="modal-backdrop">
    <div class="modal-header er-modal-head">
        <h4 class="modal-title" id="modal-basic-title">Confirmation</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>



    <div class="modal-body er-bene-modal-body">
        <p class="er-bene-delete-msg">Are you sure you want to delete this beneficiary?</p>
    </div>

    <div class="modal-footer">
        <button type="button" class="er-btn er-btn--danger" (click)="userDeletionOk()">Yes, delete</button>
        <button type="button" class="er-btn er-btn--ghost" id="tab-pane-id" (click)="modal.close('Save click')">No</button>
    </div>
</ng-template>

<ng-template #confirmationModal let-c="close" let-d="dismiss">

    <ngx-spinner bdColor="rgba(6, 7, 8, 0.88)" size="medium" color="#01DC64" type="ball-clip-rotate" [fullScreen]="true"><p style="color: white"> Processing... </p></ngx-spinner>
    <div class="modal-header er-modal-head">
        <h5 class="modal-title" id="modal-basic-title" *ngIf="numberType=='prepaid'">Confirm recharge</h5>
        <h5 class="modal-title" id="modal-basic-title" *ngIf="numberType=='postpaid'">Confirm payment</h5>

        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body er-bene-modal-body">

        <div class="er-bene-confirm-amount">{{enteredAmount | erInr}}</div>
        <p class="er-bene-confirm-line" style="text-transform: capitalize;">{{senderName}} ({{senderdata.mobile}}) is transferring</p>

        <table class="er-bene-confirm-table">

            <tr>
                <td>Sender mobile</td>
                <td>{{senderdata.mobile}}</td>
            </tr>
            <tr>
                <td>Beneficiary name</td>
                <td>{{senderdata.beneficiary_name}}</td>
            </tr>
            <tr>
                <td>Beneficiary account no</td>
                <td>{{senderdata.account_no}}</td>
            </tr>
            <tr>
                <td>Beneficiary IFSC</td>
                <td>{{senderdata.ifc_code}}</td>
            </tr>

            <tr>
                <td>Transaction mode</td>
                <td style="text-transform: uppercase;">{{transType}}</td>
            </tr>

            <tr>
                <td>Total charges from customer (incl. of applicable GST)</td>
                <td>{{customerCharges | erInr}}</td>
            </tr>
            <tr>
                <td>Commission (subject to TDS deduction as applicable)</td>
                <td>{{RetailerCommission | erInr}}</td>
            </tr>
            <tr>
                <td>Total retailer cost</td>
                <td>{{RetailorCost | erInr}}</td>
            </tr>

        </table>

    </div>
    <div class="modal-footer">
        <button type="button" class="er-btn er-btn--ghost" (click)='close(confirmationModal)'>Cancel</button>
        <button type="button" class="er-btn er-btn--primary" (click)='proceed(confirmationModal)' cdkFocusInitial>Send</button>

    </div>


</ng-template>


